<template>
    <div>
        <header-signature class="mw-100 mb-0" :text="title" />
        <div class="accordion">
            <div
                v-for="(question, index) in questionList"
                :key="'question-'+index"
            >
                <ob1-expanding-accordion-card
                    :collapsed-block-id="'collapse-'+index"
                    :link-id="'question-'+index"
                    :link-title="question.title"
                    :is-card-body-max-width="false"
                >
                    <div v-html="question.text" />
                </ob1-expanding-accordion-card>
            </div>
        </div>
    </div>
</template>

<script>

import HeaderSignature from "../../../common/components/vue/HeaderSignature.vue";

export default {
    components: {HeaderSignature},
    props: {
        title: {
            type: String,
            required: true
        },
        questionList: {
            type: Array,
            required: true
        }
    }
}
</script>
